/**
 * File: WeblinkPreviewController.js
 * Project: educore
 * Created Date: 2018-12-05
 * Author: Arul Mozhi J
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
class FlashPreviewController {
    // @ngInject
    constructor($scope, $state, $rootScope, $sce, localStorageService, UserPrivilages, filePreviewAvailable, $compile, authService, TPWIZARDCONSTANT) {
        //On init function
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }

        //On destroy function
        this.$onDestroy = () => {}

        let userId = localStorageService.get("user_id")
        let planId = $state.params.planId;
        let plan = localStorageService.get("currentPlan")
        let authoring = localStorageService.get("authoringData")
        let resourceId = $state.params.resourceId;

        $scope.toogleResource = "Show Details";
        var screenLen = screen.width;
        if (screenLen < 1281) {
            $scope.isShow = false;
        } else {
            $scope.isShow = true;
        }
        /*
         * Function To check flash is enabled or not
         * @developer - Arul Mozhi J
         */
        var isFlashEnabled = function() {
            var hasFlash = false;
            try {
                var fo = new ActiveXObject('ShockwaveFlash.ShockwaveFlash');
                if (fo) hasFlash = true;
            } catch (e) {
                if (navigator.mimeTypes["application/x-shockwave-flash"] != undefined) hasFlash = true;
            }
            return hasFlash;
        }
        var loadTemplate = () => {
            console.log(resourceId)
            if (plan) {
                $scope.resource = _.find(plan.resources, function(res) {
                    return res._id === resourceId
                })

                if ($scope.userPrev.preview && $scope.userPrev.preview.read && ($scope.userPrev.uploadAnime == undefined || ($scope.userPrev.uploadAnime && !$scope.userPrev.uploadAnime.create)) && ($scope.userPrev.approveAnime == undefined || ($scope.userPrev.approveAnime && !$scope.userPrev.approveAnime.create))) {
                    try {
                        var data = {
                            resource: {
                                type: $scope.resource.type,
                                subject_id: authoring.subject_id,
                                class_id: authoring.class_id,
                                curriculum_id: authoring.curriculum_id,
                                batch_id: authoring.batch_id,
                                session_id: authoring.session_id,
                                school_id: authoring.school_id,
                                theme_id: plan.theme_id,
                                plan_id: planId,
                                progress_data: {
                                    _id: resourceId,
                                    title: $scope.resource.title
                                }
                            },
                            user_id: userId
                        }
                        authService.callAPI(TPWIZARDCONSTANT.API_ADD_LEARNING_PROGRESS, "POST", data, () => {})
                    } catch (ex) { console.log(ex) }

                }

                if ($scope.resource) {
                    $scope.isAvailable = true
                    if ($scope.resource.url) {
                        $scope.isAvailable = true
                        console.log($scope.resource.url)
                        filePreviewAvailable.filePreviewUrl('local', $scope.resource.url, function(response) {
                            $scope.fileAvaliable = response.fileAvaliable
                            if (response.fileAvaliable) {
                                $scope.src = $sce.trustAsResourceUrl(response.fileUrl)
                                $scope.flashTemp = isFlashEnabled()
                                let playHtml = ' <div style="padding: 20px; height: 100%"><object data="' + $scope.src + '" width="100%" class="preview-outline"></object></div>';
                                angular.element(document.querySelector('.playVideoFrame')).append($compile(playHtml)($scope));
                                _.defer(() => {
                                    $scope.$apply();
                                });
                            }
                        })
                    }
                }
            }
        }
       /*Roles and Privilege*/
        let userAccess = _.filter(localStorageService.get("feature_privileges"), function(feature) {
            return feature.module_state == "flash"
        })
        $scope.userPrev = {};
        if (userAccess.length > 0) {
            _.each(userAccess, function(tpObj) {
                let user_access = {};
                _.each(tpObj.privilege, function(privObj) {
                    user_access[privObj.name.toLowerCase()] = privObj.status
                })
                $scope.userPrev[tpObj.feature_id] = user_access;
            })
            loadTemplate()
        }
    };
}

export default FlashPreviewController;


// WEBPACK FOOTER //
// ./src/app/authoring-tool/wizard/controllers/resources/flashPreview.js